/* NUVÉRA NOIR — theme.js */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  const money = (cents) => {
    const fmt = (window.nuvera && window.nuvera.moneyFormat) || '${{amount}}';
    const n = (cents / 100);
    const map = {
      amount: n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_no_decimals: Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_with_comma_separator: n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      amount_no_decimals_with_comma_separator: Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => map[k] ?? map.amount);
  };
  window.nuveraMoney = money;

  /* ---------- Letterbox intro (once per session) ---------- */
  const body = document.body;
  if (body.classList.contains('has-intro')) {
    const seen = sessionStorage.getItem('nuvera_intro');
    const open = () => {
      body.classList.add('intro-open');
      setTimeout(() => body.classList.add('intro-done'), 1800);
    };
    if (seen || reduced) { body.classList.add('intro-open', 'intro-done'); }
    else {
      sessionStorage.setItem('nuvera_intro', '1');
      window.addEventListener('load', () => setTimeout(open, 250), { once: true });
      setTimeout(open, 2500); // safety
    }
  }

  /* ---------- Header ---------- */
  const header = $('.header');
  if (header) {
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (header.dataset.hideOnScroll === 'true') {
        header.classList.toggle('is-hidden', y > 300 && y > last && !body.classList.contains('nav-open'));
      }
      last = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  const burger = $('[data-nav-toggle]');
  const drawerNav = $('[data-nav-drawer]');
  if (burger && drawerNav) {
    burger.addEventListener('click', () => {
      const open = drawerNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open);
      body.classList.toggle('nav-open', open);
      body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ---------- Search overlay ---------- */
  const searchOverlay = $('[data-search-overlay]');
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', () => {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    setTimeout(() => $('input', searchOverlay)?.focus(), 350);
  }));
  $$('[data-search-close]').forEach(b => b.addEventListener('click', () => searchOverlay?.classList.remove('is-open')));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      searchOverlay?.classList.remove('is-open');
      closeCart();
      if (drawerNav?.classList.contains('is-open')) burger?.click();
      $('.filters.is-open')?.classList.remove('is-open');
    }
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    $$('.reveal, .statement').forEach(el => io.observe(el));
  } else {
    $$('.reveal, .statement').forEach(el => el.classList.add('is-in'));
  }

  /* Split statement text into words for the staggered reveal */
  $$('.statement__text').forEach(el => {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    const walk = (node) => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(t => {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
            const s = document.createElement('span'); s.className = 'w'; s.textContent = t; frag.appendChild(s);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
    $$('.w', el).forEach((w, i) => w.style.setProperty('--i', i));
  });

  /* ---------- Cart ---------- */
  const drawer = $('[data-cart-drawer]');
  const routes = window.nuvera?.routes || {};
  const cartType = window.nuvera?.cartType || 'drawer';

  const openCart = () => { if (!drawer) return; drawer.classList.add('is-open'); body.style.overflow = 'hidden'; $('.cart-drawer__close', drawer)?.focus(); };
  const closeCart = () => { if (!drawer) return; drawer.classList.remove('is-open'); body.style.overflow = ''; };
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => {
    if (cartType !== 'drawer' || !drawer) return;
    e.preventDefault(); refreshDrawer().then(openCart);
  }));

  const refreshDrawer = async () => {
    if (!drawer) return;
    drawer.classList.add('is-loading');
    try {
      const html = await fetch(`${routes.cart}?section_id=cart_drawer`).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-drawer-inner]', doc);
      const current = $('[data-cart-drawer-inner]', drawer);
      if (fresh && current) current.replaceWith(fresh);
      bindCartLines(drawer);
      const c = $('[data-cart-count-value]', doc);
      if (c) updateCount(c.textContent);
    } catch (e) { console.error(e); }
    drawer.classList.remove('is-loading');
  };

  const updateCount = (n) => $$('[data-cart-count]').forEach(el => {
    el.textContent = n; el.hidden = String(n) === '0';
  });

  const cartChange = async (key, quantity) => {
    const res = await fetch(routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    const cart = await res.json();
    updateCount(cart.item_count);
    return cart;
  };

  const bindCartLines = (scope) => {
    $$('[data-line-key]', scope).forEach(line => {
      const key = line.dataset.lineKey;
      const input = $('input[type=number]', line);
      const set = async (q) => {
        line.style.opacity = '.4';
        await cartChange(key, q);
        if (scope === drawer) await refreshDrawer(); else location.reload();
      };
      $('[data-qty-minus]', line)?.addEventListener('click', () => set(Math.max(0, +input.value - 1)));
      $('[data-qty-plus]', line)?.addEventListener('click', () => set(+input.value + 1));
      input?.addEventListener('change', () => set(Math.max(0, +input.value)));
      $('[data-line-remove]', line)?.addEventListener('click', e => { e.preventDefault(); set(0); });
    });
  };
  bindCartLines(document);

  /* Add to cart (product form + quick add) */
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    const btn = $('[type=submit]', form);
    const label = btn?.querySelector('[data-btn-label]');
    const orig = label?.textContent;
    btn?.setAttribute('aria-disabled', 'true');
    if (label) label.textContent = 'Adding…';
    try {
      const fd = new FormData(form);
      const res = await fetch(routes.cartAdd, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      if (label) label.textContent = 'Added';
      if (cartType === 'drawer' && drawer) { await refreshDrawer(); openCart(); }
      else { window.location.href = routes.cart; }
    } catch (err) {
      const msg = $('[data-form-error]', form);
      if (msg) { msg.textContent = err.message; msg.hidden = false; }
    }
    setTimeout(() => { btn?.removeAttribute('aria-disabled'); if (label) label.textContent = orig; }, 1400);
  });

  /* ---------- Product variant picker ---------- */
  $$('[data-product]').forEach(root => {
    const dataEl = $('[data-variants-json]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('input[name=id]', form);
    const priceEl = $('[data-price]', root);
    const btn = $('[type=submit]', form);
    const label = btn?.querySelector('[data-btn-label]');
    const gallery = $('[data-gallery]', root);
    const optionInputs = $$('[data-option-index]', root);

    const selected = () => {
      const opts = [];
      optionInputs.forEach(group => {
        const idx = +group.dataset.optionIndex;
        const v = group.tagName === 'SELECT' ? group.value : ($('input:checked', group)?.value);
        opts[idx] = v;
      });
      return opts;
    };
    const update = () => {
      const opts = selected();
      let v;
      if (!optionInputs.length || variants.length === 1) {
        v = variants.find(x => String(x.id) === String(idInput.value)) || variants.find(x => x.available) || variants[0];
      } else {
        v = variants.find(x => x.options.every((o, i) => o === opts[i]));
      }
      const available = v && v.available;
      idInput.value = v ? v.id : '';
      if (priceEl && v) {
        priceEl.innerHTML = v.compare_at_price > v.price
          ? `<span class="price price--sale"><span class="price__now">${money(v.price)}</span><s>${money(v.compare_at_price)}</s></span>`
          : `<span class="price"><span class="price__now">${money(v.price)}</span></span>`;
      }
      if (btn) {
        btn.toggleAttribute('disabled', !available);
        if (label) label.textContent = !v ? 'Unavailable' : (available ? (btn.dataset.addLabel || 'Add to bag') : 'Sold out');
      }
      // mark unavailable options
      optionInputs.forEach(group => {
        const idx = +group.dataset.optionIndex;
        $$('input', group).forEach(inp => {
          const test = [...opts]; test[idx] = inp.value;
          const m = variants.find(x => x.options.every((o, i) => o === test[i]));
          inp.nextElementSibling?.classList.toggle('is-unavailable', !(m && m.available));
        });
      });
      // media
      if (v && v.featured_media && gallery) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, gallery);
        if (slide) slide.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      }
      // url
      if (v && history.replaceState) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    };
    optionInputs.forEach(g => g.addEventListener('change', update));
    update();
  });

  /* Sticky mobile buy bar */
  const sticky = $('[data-sticky-buy]');
  const mainBuy = $('[data-product-form] [type=submit]');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 }).observe(mainBuy);
    $('button', sticky)?.addEventListener('click', () => { mainBuy.closest('form').requestSubmit(); });
  }

  /* Quantity steppers (product page) */
  $$('[data-qty]').forEach(q => {
    const input = $('input', q);
    $('[data-qty-minus]', q)?.addEventListener('click', () => { input.value = Math.max(1, +input.value - 1); });
    $('[data-qty-plus]', q)?.addEventListener('click', () => { input.value = +input.value + 1; });
  });

  /* ---------- Collection filters ---------- */
  const filters = $('[data-filters]');
  if (filters) {
    $$('[data-filters-toggle]').forEach(b => b.addEventListener('click', () => filters.classList.toggle('is-open')));
    $('[data-filters-close]', filters)?.addEventListener('click', () => filters.classList.remove('is-open'));
    const form = $('form', filters);
    let t;
    form?.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => form.submit(), 250); });
    $('[data-sort]')?.addEventListener('change', e => {
      const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u;
    });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async sec => {
    if (!sec.dataset.url || sec.dataset.loaded) return;
    try {
      const html = await fetch(sec.dataset.url).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && $('.card', fresh)) { fresh.dataset.loaded = '1'; sec.replaceWith(fresh); }
    } catch (e) {}
  });

  /* ---------- Cart note ---------- */
  const note = $('[data-cart-note]');
  let nt;
  note?.addEventListener('input', () => { clearTimeout(nt); nt = setTimeout(() => fetch(routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }), 500); });

})();
